import { render, staticRenderFns } from "./index.vue?vue&type=template&id=366a9f52&scoped=true&lang=html&"
import script from "./distributionActivity.js?vue&type=script&lang=js&"
export * from "./distributionActivity.js?vue&type=script&lang=js&"
import style0 from "./distributionActivity.styl?vue&type=style&index=0&id=366a9f52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a9f52",
  null
  
)

export default component.exports